import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'app-imprint',
  templateUrl: './imprint.html',
  styleUrls: ['./imprint.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: []
})
export class ImprintComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
